export default "__VITE_ASSET__a1af48bb__"